import { useEffect, useMemo } from 'react';
import {
  ArrayInput,
  ArrayInputProps,
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  required,
  SimpleFormIterator,
  useRecordContext,
  TextInput,
} from 'react-admin';
import { LinesDescriptionInput } from './LinesDescriptionInput';
import { LinesPriceInput } from './LinesPriceInput';
import { LineTaxInput } from './LinesTaxInput';
import { LinesTypeField } from './LinesTypeField';
import { TotalPriceField } from './LineTotalPriceField';
import { useFormContext, useWatch } from 'react-hook-form';

export const LinesInput = (props: Omit<ArrayInputProps, 'children'>) => {

  const { setValue, getValues } = useFormContext();

  const record = useRecordContext();
  
  return (
    <ArrayInput
      label="resources.contracts.lines.name"
      sx={{
        '& .RaSimpleFormIterator-form': {
          flexDirection: 'row !important',
          gap: '15px',
          alignItems: 'center !important',
        },
      }}
      {...props}
    >
      <SimpleFormIterator disableReordering>
        <ReferenceInput source="item" reference="items">
          <AutocompleteInput
            label="resources.contracts.fields.item"
            filterToQuery={(searchText) => ({
              '%FullyQualifiedName%': searchText,
            })}
            optionText={(item) => item.FullyQualifiedName}
            optionValue="id"
            validate={required()}
            sx={{
              width: 350,
            }}
          />
        </ReferenceInput>
        <LinesTypeField source="type"/>
        <LinesDescriptionInput
          source="description"
          label="resources.items.fields.Description"
          sx={{
            width: 250,
          }}
        />
        <LinesPriceInput
          source="price"
          label="resources.items.fields.UnitPrice"
          sx={{
            width: 100,
          }}
        />
        <NumberInput
          source="quantity"
          defaultValue={1}
          min={0}
          max={100}
          sx={{
            width: 70,
          }}
          label="resources.contracts.fields.quantity"
        />
        <TotalPriceField 
          source="total"
          sx={{
            width: 70,
          }}
         />
        <LineTaxInput
          sx={{
            width: 200,
          }}
          source="tax"
          filter={{"active": true}}
          reference="taxes"
          label="resources.contracts.fields.tax"
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
};
